import React, { useEffect } from "react";
import { Header } from "../../internal/Header/Header";
import Footer from "../NewLandingPage/components/Footer";
import { Helmet } from "react-helmet";
import { Hero } from "../Resources/Webinar";
import { Images } from "../../../assets/images";
import {
  PageContainer,
  ContentSection,
  ClauseCard,
  ClauseList,
  ClausePoint,
  HeroTitle,
} from "../Resources/ModelClauses";
import { HyperLink } from "../../common/FormInputs";

function MediationClauseRules(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const clauses = [
    {
      title: "IAMC Model Mediation Clause",
      points: [
        <>
          In the event of any dispute arising out of or in connection with
          anything contained in the Agreement or otherwise, such dispute shall
          be referred to by Parties, for{" "}
          <HyperLink
            onClick={() =>
              window.open(`https://user.iamch.org.in/mediation-model-clause`)
            }
          >
            mediation
          </HyperLink>{" "}
          through IAMC [www.iamch.org.in] ("Institution").
        </>,
        "The parties may use any other ADR institution provided such Institution is as agreed mutually by the parties.",
        "The Institution shall, among other things, appoint a neutral Mediator/Conciliator and provide a platform for settlement of dispute between the parties as per the mediation Rules of the Institution.",
        "Should this clause create a contradiction with a statutory requirement or a judicial mandate to resolve certain types of disputes through specific courts, the statutory requirement shall prevail.",
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>
          Mediation and Conciliation Model Clause - Dispute Resolution Clauses -
          IAMC
        </title>
        <meta
          name="description"
          content="Learn about the IAMC Mediation & Conciliation Model Clause."
        />
        <meta
          name="keywords"
          content="Mediation and Conciliation Clause Rules, Mediation and Conciliation Model Clause Rules, Mediation Clause Rules, Conciliation Clause Rules, Online Mediation, IAMC"
        />
      </Helmet>

      <div>
        <Header>
          <PageContainer>
            <Hero bgImage={Images.modalClause}>
              <HeroTitle>Mediation Model Clause</HeroTitle>
            </Hero>

            <ContentSection>
              {clauses.map((clause, index) => (
                <ClauseCard key={index}>
                  <ClauseList>
                    {clause.points.map((point, pointIndex) => (
                      <ClausePoint key={pointIndex}>{point}</ClausePoint>
                    ))}
                  </ClauseList>
                </ClauseCard>
              ))}
            </ContentSection>
          </PageContainer>
        </Header>
        <Footer />
      </div>
    </>
  );
}

export default MediationClauseRules;
